import React, { useState } from 'react';
import { useEffect } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { firestore } from "../helpers/firebaseConfig";

import "./ModelUI.css"
import ModelBuilderChatComponent from './SectionScreens/ModelBuilderChatComponent';
import ModelBuilderMapComponent from './SectionScreens/ModelBuilderMapComponent';
import { cloudRunHello, cloudRunRunGraph, cloudRunRunParcels } from '../helpers/AI_functions';

function ModelBuilderUI() {
  const [state, setState] = useState({
    contraflow: false,
    blockedRoads: 0,
    time: 0,
    dynamic_data: [],
    mapDataText: null,
    generalMapLegendText: '',
    selectedLinkIds: [],
    selectedNodeIds: [],
    maxTime: 0,
    selectedSimulationId: 'simulation_1',
    ticketStatuses: {},
    tickets: [],
    focusTicket: null
  });

  const [currentChatId, setCurrentChatId] = useState('new_111');   // default chat
  const [sidebarOpen, setSidebarOpen] = useState(false); 

  const updateState = upd => setState(p => ({ ...p, ...upd }));

  useEffect(() => {
    cloudRunHello().then((r) => { 
      if(r.ok)
          console.log("Message here", r.text)
      else
        console.log("Error") 
      });

      /*
    cloudRunRunGraph({
      coords: [
        [-122.418184, 37.640244],
        [-122.413067, 37.641366],
        [-122.413185, 37.632649],
      ],
      model_id: "simulation_5",
      prefix: "berkeley",
      blockId: "test_1"}
    ).then((r) => { 
      if(r.ok)
          console.log("Message here", r.text)
      else
        console.log("Error") 
    });
    */

    /* cloudRunRunParcels({
      coords: [
        [-122.418184, 37.640244],
        [-122.413067, 37.641366],
        [-122.413185, 37.632649],
      ],
      model_id: "simulation_5",
      prefix: "berkeley",
      blockId: "test_2"}
    ).then((r) => { 
      if(r.ok)
          console.log("Message here", r.text)
      else
        console.log("Error") 
    });
    */

  }, []);

  useEffect(() => {
    const unsub = onSnapshot(
      collection(
        firestore,
        "model_builders", // Earlier, it was "simulations"
        state.selectedSimulationId,
        "model_tickets"
      ),
      snap => {
        const statusMap = {};
        const ticketsArr = [];

        snap.forEach((d) => {
          const data = d.data();
          if (!data?.id) return;

          ticketsArr.push({ ...data, simulationId: state.selectedSimulationId });

          if (data.status) statusMap[data.id] = data.status;
        });

        setState((p) => ({
          ...p,
          ticketStatuses: statusMap,
          tickets: ticketsArr
        }));
      }
    );
    return () => unsub();
  }, [state.selectedSimulationId]);

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      background: '#1E1E1E',
      color: '#FFF'
    }}>

    <button
      onClick={() => setSidebarOpen(!sidebarOpen)}
      style={{
        position: 'fixed',
        bottom: '10px',
        left:  '10px',
        width: '30px',
        height:'30px',
        borderRadius: '20px',
        border: 'none',
        fontSize: '20px',
        background: '#007BFF',
        color: '#FFF',
        cursor: 'pointer',
        zIndex: 1100     // one layer above Sidebar
      }}
    >
      ☰
    </button>

      {/* main area */}
      <div style={{ flex: 1, padding: 20 }}>
        <div className="model-ui-container">
          <div className="model-chat-section">
            <ModelBuilderChatComponent
              state={state}
              updateState={updateState}
              tickets={state.tickets}
              chatId={currentChatId}        /* ← pass active chat id */
            />
          </div>
          <div className="model-map-section">
            <ModelBuilderMapComponent state={state} updateState={updateState} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModelBuilderUI;